/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable no-undef */
import React from "react"
import cheerio from "cheerio"
import { Header } from "../../components/common"
import Helmet from "react-helmet"

export default props => {
  if (!props.post.feature_image) {
    const html = cheerio.load(props.post.html)
    html(`ul`).addClass(`p-list pb-4`)
    html(`p`).addClass(`pb-5`)
    html(`h4`).addClass(`pb-4`)
    html(`img`).addClass(`text-center m-auto pb-5`)
    return (
      <>
        <Helmet>
          <title>Tarento - Careers | {props.post.title} | Apply Now</title>
          <meta
            name="twitter:title"
            content={`Tarento - Careers | JOIN THE T-CREW | ${props.post.title}`}
          ></meta>
          <meta
            property="og:title"
            content={`Tarento - Careers | JOIN THE T-CREW | ${props.post.title}`}
          ></meta>
          <meta
            property="og:image"
            content="https://www.tarento.com/images/career/job.png"
          ></meta>
          <meta
            name="twitter:image"
            content="https://www.tarento.com/images/career/job.png"
          ></meta>
          <meta name="description" content={props.post.meta_description}></meta>
          <meta
            name="og:description"
            content={props.post.meta_description}
          ></meta>
          <meta
            name="twitter:description"
            content={props.post.meta_description}
          ></meta>
          <meta
            name="twitter:card"
            content={props.post.meta_description}
          ></meta>
          <meta property="og:type" content="jobs"></meta>
          <meta property="og:locale" content="en_US" />
          <meta
            name="twitter:url"
            content={`https://www.tarento.com/${props.post.url.split("/")[3]}/`}
          ></meta>
          <meta
            property="og:url"
            content={`https://www.tarento.com/${props.post.url.split("/")[3]}/`}
          ></meta>
          <meta name="twitter:site" content={props.post.title}></meta>
          <link href={`https://www.tarento.com/${props.post.url.split("/")[3]}/`} rel="canonical"></link>
        </Helmet>
        <Header />
        <div className="jumbotron layoutBg" id="info">
          <div className="container">
            <div className="row  align-items-center">
              <div className="col-md-8 col-lg-6 mr-lg-5">
                <div className="digitalInfo">
                  <h1 className="h2 h2LS text-uppercase">{props.post.title}</h1>
                  <h3 className="b6 h6" style={{ whiteSpace: "pre" }}>
                    {props.post.meta_description}
                  </h3>
                  <div className="applyJobs">
                    <a
                      href={`mailto:careers@tarento.com?subject=${props.post.title}`}
                      className="btn btn-primary mt-3 mr-2"
                    >
                      Apply for this job
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-lg-5">
                <div className="digitalImg mt-4">
                  <img src="/images/career/job.png" alt="Jobs" title="Jobs" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="layout load-external-scripts">
          <div className="container">
            <div className="row">
              <div className="col-md-10 m-auto">
                <div className="titleSection">
                  <div dangerouslySetInnerHTML={{ __html: html.html() }}></div>
                  <div className="applyJobs">
                    <a
                      href={`mailto:careers@tarento.com?subject=${props.post.title}`}
                      className="btn btn-primary mt-3 mr-2"
                    >
                      Apply for this job
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  } else {
    return (
      <>
        <p>Not Available</p>
      </>
    )
  }
}